const getURL = () => {
  return window.location.origin;
};

export default getURL;
